import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import QuoteBuilder from "@/components/QuoteBuilder";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/AuthPages";
import AccountPage from "@/pages/AccountPage";
import SavedQuotesPage from "@/pages/SavedQuotesPage";
import LeadsPage from "@/pages/LeadsPage";
import AboutPage from "@/pages/AboutPage";
import CustomersPage from "@/pages/CustomersPage";
import LegalPage from "@/pages/LegalPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentResult";
import { Loader2 } from "lucide-react";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-[#A6844A]" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<QuoteBuilder />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/account" element={<Protected><AccountPage /></Protected>} />
            <Route path="/quotes" element={<Protected><SavedQuotesPage /></Protected>} />
            <Route path="/leads" element={<Protected><LeadsPage /></Protected>} />
            <Route path="/customers" element={<Protected><CustomersPage /></Protected>} />
            <Route path="/privacy" element={<LegalPage doc="privacy" />} />
            <Route path="/terms" element={<LegalPage doc="terms" />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
